import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastService } from "@app/core/services/toast.service";
import { Store } from '@ngrx/store';
import { AppState } from '@app/core/store/app.state';
import * as UserAuthActions from '@app/core/store/userAuth/userAuth.actions';
import { LogoutType } from '@app/core/enums/logout-types.enum';
import { TokenStorageService } from '../services/token-storage.service';

@Injectable()
export class AuthenticationErrorInterceptor implements HttpInterceptor {
  constructor(
    private toastService: ToastService,
    private store: Store<AppState>,
    private tokenStorageService: TokenStorageService
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: any) => {
        if (error instanceof HttpErrorResponse) {
          switch(error.status) {
            case 401:
              if (this.tokenStorageService.getUser()) {
                this.store.dispatch(
                  UserAuthActions.LogoutSuccess({ logoutType: LogoutType.INACTIVITY })
                );              }
              return throwError(() => error);
              break;
            case 403:
              return throwError(() => error);
              break;
          }
          // Handle errors other than 401/403 → show toast
          // this.tokenStorageService.clearStorage();
          this.toastService.showErrorToast('Something went wrong. Please try again.');
        }
        return throwError(() => error);
      })
    );
  }
}
